import { ListFilters } from "apps/customLists/components/filterScreens";
import { useTagByIdsQuery, useTagGroupByIdsQuery } from "gql/generated";

export const useGetTagsAndTagGroupsByListFilters = (
  filters: ListFilters | undefined,
) => {
  // Rather than querying tags & tagGroups per filter we are querying them once
  // here as they are apart of multiple filters
  const {
    data: tags,
    loading: tagsLoading,
    error: tagsError,
  } = useTagByIdsQuery({
    variables: {
      ids: filters?.tags.businessType
        .concat(filters?.tags.global)
        .concat(filters?.tags.organizationSpecific)
        .concat(filters?.tags.amenity),
      limit: 10000,
    },
  });

  const {
    data: tagGroups,
    loading: tagGroupsLoading,
    error: tagGroupsError,
  } = useTagGroupByIdsQuery({
    variables: {
      ids: filters?.filledTagGroups.businessType
        .concat(filters?.filledTagGroups.global)
        .concat(filters?.filledTagGroups.organizationSpecific)
        .concat(filters?.filledTagGroups.amenity),
      limit: 10000,
    },
  });

  return {
    tags: tags?.tagByIds,
    tagGroups: tagGroups?.tagGroupByIds,
    error: tagsError || tagGroupsError,
    loading: tagsLoading || tagGroupsLoading,
  };
};
